<script>
    import Scroller from '@sveltejs/svelte-scroller';

    let index;
	let offset;
	let progress;

</script>

<Scroller top="{1}" bottom="{1}" bind:index bind:offset bind:progress>
    <div slot="background">
        <div class="wrapper center">
            <div class="label" id="label-wd">
                <div style="color: var(--warm-40); margin-bottom: var(--spacing-1);">Lake Mead Water Level</div>
                1,300 ft
            </div>
            <div class="ruler">
                <div class="top-end"></div>
                {#each {length: 4} as _, i}
                    <div class="divider">
                        {#each {length: 2} as _, j}
                            <div class="divider-half">
                                {#each {length: 2} as _, k}
                                    <div class="divider-half">
                                        {#each {length: 2} as _, l}
                                            <div class="divider-half"></div>
                                        {/each}
                                        {#if j == 1 && k == 1}
                                            <div class="label">
                                                {#if i == 1}
                                                    1,100 ft
                                                {:else if i == 0}
                                                    1,200 ft
                                                {:else}
                                                    1,000 ft
                                                {/if}
                                            </div>
                                        {/if}
                                    </div>
                                {/each}
                            </div>
                        {/each}
                    </div>
                {/each}
            </div>
            <div 
                class="water-bkgd"
                class:water-bkgd2="{offset > 0.6}"
                style="height: {Math.max(Math.min((1 - offset) * 100, 92), 15) }%;">
            </div>
        </div>
    </div>
    <div slot="foreground">
        <section></section>
    </div>
</Scroller>

<style lang="scss">
    @import "@propublica/pp-v5-shared/src/css/column-setter-and-deps";

    .wrapper {
        height: 50vh;
        position: relative;
        overflow: hidden;

        @include breakpoint-max(md) {
            height: 400px;
        }
    }

	[slot="foreground"] {
		pointer-events: none;
	}

	[slot="foreground"] section {
		pointer-events: all;
	}
	
	section {
		height: 50vh;

        @include breakpoint-max(md) {
            height: 400px;
        }
	}
    mark {
        padding: 0.5em;
        position: fixed;
        bottom: 0;
        right: 0;
    }

    .water-bkgd {
        position: absolute;
        width: 100%;
        bottom: 0;
        left: 0;
        z-index: -2;
        height: 0;
        animation: waves 4s ease-in-out infinite;
        background: linear-gradient(
            0deg,
            rgba(195, 220, 226, 1) 5%,
            rgba(195, 220, 226, 0.95) 50%,
            rgba(195, 220, 226, 0.8) 100%,
        );
        transition: height 0.2s;
        transition-timing-function: ease;
    }

    .water-bkgd2 {
        animation: waves2 4s ease-in-out infinite;
    }

@keyframes waves {
    0%, 100% { 
        clip-path: polygon(0 4%, 7% 3%, 14% 2.5%, 21% 2.5%, 28% 3%, 34% 4%, 40% 6%, 46% 8.5%, 50% 10%, 54% 11.5%, 60% 12.5%, 66% 13%, 70% 13%, 77% 12.5%, 83% 11.5%, 89% 10.5%, 95% 9.5%, 100% 8.5%, 100% 100%, 0% 100%);
    }

    50% {
        clip-path: polygon(0 7.5%, 9% 10.5%, 14% 11.5%, 18% 12.5%, 21% 13%, 30% 14%, 32% 14%, 40% 13.5%, 46% 13%, 52% 11.5%, 57% 9.5%, 62% 7.5%, 68% 5.5%, 73% 4%, 79% 3%, 86% 2.5%, 93% 2.5%, 100% 3%, 100% 100%, 0% 100%);
    }
}

@keyframes waves2 {
  0%, 100% {
    clip-path: polygon(0 8%, 7% 6%, 14% 5%, 21% 5%, 28% 6%, 34% 8%, 40% 12%, 46% 17%, 50% 20%, 54% 23%, 60% 25%, 66% 26%, 70% 26%, 77% 25%, 83% 23%, 89% 21%, 95% 19%, 100% 17%, 100% 100%, 0% 100%);
  }

  50% {
    clip-path: polygon(0 15%, 9% 21%, 14% 23%, 18% 25%, 21% 26%, 30% 28%, 32% 28%, 40% 27%, 46% 26%, 52% 23%, 57% 19%, 62% 15%, 68% 11%, 73% 8%, 79% 6%, 86% 5%, 93% 5%, 100% 6%, 100% 100%, 0% 100%);
  }
}
    .ruler {
        background-color: #fff;
        margin-left: calc(50vw - var(--spacing-1) * 4);
        width: calc(var(--spacing-1) * 8);
        height: 140%;
        border: var(--intro-stroke);
        border-bottom: 0;
        z-index: -3;
        position: relative;
        display: flex;
        flex-direction: column;
    }

    .label {
        font-family: var(--fonts-sans);
        font-size: var(--scale-3);
        letter-spacing: 2px;
        color: var(--color-text-body);
        line-height: var(--line-height-1);
        position: relative;
        font-weight: 800;
        margin-left: 50vw;
        text-align: center;
        width: calc(var(--spacing-1) * 8 - 5px);
        text-transform: uppercase;
        z-index: -3;

        &#label-wd {
            width: calc(var(--spacing-1) * 10);
            margin-left: calc(50vw - var(--spacing-1) * 5);
            position: relative;
        }
    }

    .top-end {
        border-bottom: 3.6px solid #000;
    }
    
    .divider {
        border-bottom: 4.2px solid #000;
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: end;
    }

    .divider-half {
        flex: 1;
        border-bottom: 4.2px solid #000;
        width: 50%;
        display: flex;
        flex-direction: column;
        align-items: end;

        &:nth-child(2) {
            border-bottom: 0;
            position: relative;
        }

        .label {
            position: absolute;
            bottom: 0;
            line-height: 12px;
        }
    }
    

</style>